// Backend auto-generates one purpose per collection named `on-archive-<uuid>`.
const GENERATED_UUID_SUFFIX =
  /-[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export const getPurposeBaseName = (name: string) =>
  (name?.split('::')[0] || name)?.replace(GENERATED_UUID_SUFFIX, '');
